<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <b-card>
      <b-row class="mb-2">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label for="filter_cluster">Filter By Cluster</label>
            <v-select
              id="filter_cluster"
              v-model="selected.cluster"
              :options="list.clusters"
              label="cluster_name"
              :disabled="state.busy"
              placeholder="-- Please Select Cluster --"
            >
              <template #option="{ cluster_name }">
                <span>{{ cluster_name }}</span>
              </template>
              <template #no-options="">
                No Available Clusters
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label for="filter_area">Filter By Area</label>
            <v-select
              id="filter_area"
              v-model="selected.area"
              :options="list.filter_areas"
              label="area_name"
              :disabled="state.busy"
              placeholder="-- Please Select Area --"
            >
              <template #option="{ area_name }">
                <span>{{ area_name }}</span>
              </template>
              <template #no-options="">
                No Available Areas
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <div class="form-group">
            <label>Filter By Status</label>
            <b-select
              v-model="filter.status"
              :options="filterStatuses"
              @change="onFilterChanged"
            />
          </div>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Search String</label>
            <b-input
              v-model="tableSettings.filter"
              type="text"
              placeholder="Enter search string"
              debounce="1000"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-table
        ref="table"
        hover
        responsive
        class="mt-2"
        :per-page="tableSettings.perPage"
        :current-page="tableSettings.currentPage"
        :items="myProvider"
        :fields="tableSettings.fields"
        :sort-by.sync="tableSettings.sortBy"
        :sort-desc.sync="tableSettings.sortDesc"
        :sort-direction="tableSettings.sortDirection"
        :filter="tableSettings.filter"
        :filter-included-fields="tableSettings.filterOn"
        show-empty
      >
        <template #cell(index)="data">
          {{ tableSettings.currentPage * tableSettings.perPage - tableSettings.perPage + (data.index + 1) }}
        </template>

        <template #cell()="data">
          <div class="text-nowrap">
            {{ data.value }}
          </div>
        </template>

        <template #cell(actions)="row">
          <div class="text-nowrap">
            <b-button
              size="sm"
              class="mr-1"
              @click="onShowEditForm(row.item)"
            >
              Update
            </b-button>
            <!-- <b-button
              size="sm"
              variant="success"
              @click="onShowLogActivityForm(row.item)"
            >
              Log Activity
            </b-button> -->
          </div>
        </template>
      </b-table>

      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="w-100 w-sm-25 mb-2 sm-mb-2">
            <b-select
              v-model="tableSettings.perPage"
              :options="tableSettings.pageOptions"
              size="sm"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="tableSettings.currentPage"
            :total-rows="tableSettings.totalRows"
            :per-page="tableSettings.perPage"
            first-number
            last-number
            pills
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-dealer-form"
      scrollable
      no-close-on-backdrop
      title="Dealer Master Data"
      size="xl"
      @ok="onConfirmAction"
    >
      <ValidationObserver
        ref="form"
      >
        <form
          role="form"
          novalidate
        >
          <b-tabs
            class="px-2"
            no-body
          >
            <b-tab
              title="Basic Information"
              active
            >
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="status"
                    vid="status"
                    rules="required"
                  >
                    <b-form-group>
                      <label for="status"><strong>Status</strong></label>
                      <b-form-select
                        id="status"
                        v-model="dealer.status"
                        :options="options.statuses"
                        :state="errors.length > 0 ? false : null"
                        :disabled="state.busy"
                      >
                        <template #first>
                          <b-form-select-option
                            :value="null"
                            disabled
                          >
                            -- Please Select Status --
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="partner code"
                    vid="partner_code"
                    rules=""
                  >
                    <b-form-group>
                      <label for="partner_code"><strong>Partner Code</strong></label>
                      <b-input
                        id="partner_code"
                        v-model="dealer.partner_code"
                        type="text"
                        :state="errors.length > 0 ? false : null"
                        placeholder="enter partner code"
                        autocomplete="off"
                        :disabled="true"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="partner name"
                    vid="partner_name"
                    rules=""
                  >
                    <b-form-group>
                      <label for="partner_name"><strong>Partner Name</strong></label>
                      <b-input
                        id="partner_name"
                        v-model="dealer.partner_name"
                        type="text"
                        :state="errors.length > 0 ? false : null"
                        placeholder="enter partner name"
                        autocomplete="off"
                        :disabled="true"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="cluster"
                    vid="cluster"
                    rules="required"
                  >
                    <b-form-group>
                      <label for="cluster"><strong>Cluster</strong></label>
                      <v-select
                        id="cluster"
                        v-model="selected2.cluster"
                        :options="list.clusters"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="cluster_name"
                        :disabled="state.busy"
                      >
                        <template #option="{ cluster_name }">
                          <strong>{{ cluster_name }}</strong>
                        </template>
                        <template #no-options="">
                          No Available Clusters
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="areas"
                    vid="areas"
                    rules="required"
                  >
                    <b-form-group>
                      <label for="area"><strong>Area</strong></label>
                      <v-select
                        id="area"
                        v-model="selected2.area"
                        :options="list.areas"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="area_name"
                        :disabled="state.busy"
                      >
                        <template #option="{ area_name }">
                          <strong>{{ area_name }}</strong>
                        </template>
                        <template #no-options="">
                          No Available Areas
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="distribution"
                    vid="distribution"
                    rules="required"
                  >
                    <b-form-group>
                      <label for="distribution"><strong>Distribution</strong></label>
                      <v-select
                        id="distribution"
                        v-model="selected2.distribution"
                        :options="list.distributions"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="distribution_name"
                        :disabled="state.busy"
                      >
                        <template #option="{ distribution_name }">
                          <strong>{{ distribution_name }}</strong>
                        </template>
                        <template #no-options="">
                          No Available Distributions
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col cols="12">
                  <b-form-group>
                    <label for="business_address"><strong>Business Address</strong></label>
                    <b-input
                      id="business_address"
                      v-model="dealer.business_address"
                      type="text"
                      placeholder="enter business address"
                      autocomplete="off"
                      :disabled="state.busy"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="province"
                    vid="province_one"
                    rules=""
                  >
                    <b-form-group>
                      <label for="province_one"><strong>Province (Business Address)</strong></label>
                      <v-select
                        id="province_one"
                        v-model="selected2.province_one"
                        :options="list.provinces"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="province_name"
                        :disabled="state.busy"
                      >
                        <template #option="{ province_name }">
                          <strong>{{ province_name }}</strong>
                        </template>
                        <template #no-options="">
                          No Available Provinces
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="municipality"
                    vid="municipality_one"
                    rules=""
                  >
                    <b-form-group>
                      <label for="municipality_one"><strong>Municipality (Business Address)</strong></label>
                      <v-select
                        id="municipality_one"
                        v-model="selected2.municipality_one"
                        :options="list.municipalities_one"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="municipality_name"
                        :disabled="state.busy"
                      >
                        <template #option="{ municipality_name }">
                          <strong>{{ municipality_name }}</strong>
                        </template>
                        <template #no-options="">
                          No Available Municipalities
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="barangay"
                    vid="barangay_one"
                    rules=""
                  >
                    <b-form-group>
                      <label for="barangay_one"><strong>Barangay (Business Address)</strong></label>
                      <v-select
                        id="barangay_one"
                        v-model="selected2.barangay_one"
                        :options="list.barangays_one"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="barangay_name"
                        :disabled="state.busy"
                      >
                        <template #option="{ barangay_name }">
                          <strong>{{ barangay_name }}</strong>
                        </template>
                        <template #no-options="">
                          No Available Barangays
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col cols="12">
                  <b-form-group>
                    <label for="home_address"><strong>Home Address</strong></label>
                    <b-input
                      id="home_address"
                      v-model="dealer.home_address"
                      type="text"
                      placeholder="enter home address"
                      autocomplete="off"
                      :disabled="state.busy"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="province"
                    vid="province_two"
                    rules=""
                  >
                    <b-form-group>
                      <label for="province_two"><strong>Province (Home Address)</strong></label>
                      <v-select
                        id="province_two"
                        v-model="selected2.province_two"
                        :options="list.provinces"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="province_name"
                        :disabled="state.busy"
                      >
                        <template #option="{ province_name }">
                          <strong>{{ province_name }}</strong>
                        </template>
                        <template #no-options="">
                          No Available Provinces
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="municipality"
                    vid="municipality_two"
                    rules=""
                  >
                    <b-form-group>
                      <label for="municipality_two"><strong>Municipality (Home Address)</strong></label>
                      <v-select
                        id="municipality_two"
                        v-model="selected2.municipality_two"
                        :options="list.municipalities_two"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="municipality_name"
                        :disabled="state.busy"
                      >
                        <template #option="{ municipality_name }">
                          <strong>{{ municipality_name }}</strong>
                        </template>
                        <template #no-options="">
                          No Available Municipalities
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="barangay"
                    vid="barangay_two"
                    rules=""
                  >
                    <b-form-group>
                      <label for="barangay_two"><strong>Barangay (Home Address)</strong></label>
                      <v-select
                        id="barangay_two"
                        v-model="selected2.barangay_two"
                        :options="list.barangays_two"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="barangay_name"
                        :disabled="state.busy"
                      >
                        <template #option="{ barangay_name }">
                          <strong>{{ barangay_name }}</strong>
                        </template>
                        <template #no-options="">
                          No Available Barangays
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

              </b-row>
            </b-tab>

            <b-tab
              title="Contact Persons"
            >
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="name"><strong>Name</strong> <span class="text-danger">*</span></label>
                    <b-input
                      id="name"
                      v-model="representative.name"
                      type="text"
                      placeholder="enter name"
                      autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="birth_date"><strong>Birth Date</strong></label>
                    <b-input
                      id="birth_date"
                      v-model="representative.birth_date"
                      type="date"
                      placeholder="enter birth date"
                      autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="phone_one"><strong>Telephone 1</strong></label>
                    <b-input
                      id="phone_one"
                      v-model="representative.phone_one"
                      type="text"
                      placeholder="enter phone number"
                      maxlength="20"
                      autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="phone_two"><strong>Telephone 2</strong></label>
                    <b-input
                      id="phone_two"
                      v-model="representative.phone_two"
                      type="text"
                      placeholder="enter phone number"
                      maxlength="20"
                      autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="mobile_one"><strong>Mobile 1</strong> <span class="text-danger">*</span></label>
                    <b-input
                      id="mobile_one"
                      v-model="representative.mobile_one"
                      type="text"
                      placeholder="enter mobile number"
                      maxlength="11"
                      autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="mobile_two"><strong>Mobile 2</strong></label>
                    <b-input
                      id="mobile_two"
                      v-model="representative.mobile_two"
                      type="text"
                      placeholder="enter mobile number"
                      maxlength="11"
                      autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="email"><strong>Email</strong></label>
                    <b-input
                      id="email"
                      v-model="representative.email"
                      type="email"
                      placeholder="enter email"
                      maxlength="100"
                      autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <b-form-group>
                    <label for="viber"><strong>Viber</strong></label>
                    <b-input
                      id="viber"
                      v-model="representative.viber"
                      type="text"
                      placeholder="enter viber"
                      maxlength="50"
                      autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-button
                    class="mr-2"
                    type="button"
                    :variant="representativeButtonVariant"
                    :disabled="representativeButtonDisabledState"
                    @click="onRepresentativeButtonClick"
                  >
                    {{ representativeButtonLabel }}
                  </b-button>
                  <b-button
                    v-if="state.representativeEditing"
                    type="button"
                    variant="danger"
                    @click="onRepresentativeCancelUpdate"
                  >
                    Cancel Update
                  </b-button>
                </b-col>

                <b-col
                  cols="12"
                  class="mt-2"
                >
                  <b-table
                    ref="table-crop-details"
                    hover
                    responsive
                    show-empty
                    :fields="tableRepresetativeSettings.fields"
                    :items="filteredRepresentatives"
                  >
                    <template #cell(index)="data">
                      {{ tableRepresetativeSettings.currentPage * tableRepresetativeSettings.perPage - tableRepresetativeSettings.perPage + (data.index + 1) }}
                    </template>

                    <template #cell()="data">
                      <div class="text-nowrap">
                        {{ data.value }}
                      </div>
                    </template>

                    <template #cell(actions)="row">
                      <div class="text-nowrap">
                        <b-button
                          size="sm"
                          variant="success"
                          class="mr-2"
                          :disabled="state.representativeEditing"
                          @click="onRepresentativeEdit(row.item)"
                        >
                          Edit
                        </b-button>

                        <b-button
                          v-if="isNaN(parseInt(row.item.id))"
                          size="sm"
                          variant="danger"
                          :disabled="state.representativeEditing"
                          @click="onRepresentativeRemove(row.item)"
                        >
                          Remove
                        </b-button>
                      </div>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-tab>

            <b-tab
              title="Stores"
            >
              <b-row>
                <b-col
                  cols="12"
                >
                  <b-form-group>
                    <label for="store_name"><strong>Store Name</strong> <span class="text-danger">*</span></label>
                    <b-input
                      id="store_name"
                      v-model="store.store_name"
                      type="text"
                      placeholder="enter store name"
                      maxlength="255"
                      autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                >
                  <b-form-group>
                    <label for="store_address"><strong>Store Address</strong> <span class="text-danger">*</span></label>
                    <b-input
                      id="store_address"
                      v-model="store.store_address"
                      type="text"
                      placeholder="enter store address"
                      maxlength="255"
                      autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <b-form-group>
                    <label for="province_three"><strong>Province</strong></label>
                    <v-select
                      id="province_three"
                      v-model="selected3.province"
                      :options="list.provinces"
                      label="province_name"
                    >
                      <template #option="{ province_name }">
                        <strong>{{ province_name }}</strong>
                      </template>
                      <template #no-options="">
                        No Available Provinces
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <b-form-group>
                    <label for="municipality_three"><strong>Municipality</strong></label>
                    <v-select
                      id="municipality_three"
                      v-model="selected3.municipality"
                      :options="list.municipalities_three"
                      label="municipality_name"
                    >
                      <template #option="{ municipality_name }">
                        <strong>{{ municipality_name }}</strong>
                      </template>
                      <template #no-options="">
                        No Available Municipalities
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="4"
                >
                  <b-form-group>
                    <label for="barangay_three"><strong>Barangay</strong></label>
                    <v-select
                      id="barangay_three"
                      v-model="selected3.barangay"
                      :options="list.barangays_three"
                      label="barangay_name"
                    >
                      <template #option="{ barangay_name }">
                        <strong>{{ barangay_name }}</strong>
                      </template>
                      <template #no-options="">
                        No Available Barangays
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-button
                    class="mr-2"
                    type="button"
                    :variant="storeButtonVariant"
                    :disabled="storeButtonDisabledState"
                    @click="onStoreButtonClick"
                  >
                    {{ storeButtonLabel }}
                  </b-button>
                  <b-button
                    v-if="state.storeEditing"
                    type="button"
                    variant="danger"
                    @click="onStoreCancelUpdate"
                  >
                    Cancel Update
                  </b-button>
                </b-col>

                <b-col
                  cols="12"
                  class="mt-2"
                >
                  <b-table
                    ref="table-crop-details"
                    hover
                    responsive
                    show-empty
                    :fields="tableStoreSettings.fields"
                    :items="filteredStores"
                  >
                    <template #cell(index)="data">
                      {{ tableStoreSettings.currentPage * tableStoreSettings.perPage - tableStoreSettings.perPage + (data.index + 1) }}
                    </template>

                    <template #cell()="data">
                      <div class="text-nowrap">
                        {{ data.value }}
                      </div>
                    </template>

                    <template #cell(actions)="row">
                      <div class="text-nowrap">
                        <b-button
                          size="sm"
                          variant="success"
                          class="mr-2"
                          :disabled="state.storeEditing"
                          @click="onStoreEdit(row.item)"
                        >
                          Edit
                        </b-button>

                        <b-button
                          v-if="isNaN(parseInt(row.item.id))"
                          size="sm"
                          variant="danger"
                          :disabled="state.storeEditing"
                          @click="onStoreRemove(row.item)"
                        >
                          Remove
                        </b-button>
                      </div>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-tab>

            <b-tab
              title="Call Disposition"
            >
              <b-row>
                <b-col cols="12">
                  <b-table
                    ref="tableChannelDisposition"
                    hover
                    responsive
                    class="mt-2"
                    :per-page="tableCallLogSettings.perPage"
                    :current-page="tableCallLogSettings.currentPage"
                    :items="myLogProvider"
                    :fields="tableCallLogSettings.fields"
                    :sort-by.sync="tableCallLogSettings.sortBy"
                    :sort-desc.sync="tableCallLogSettings.sortDesc"
                    :sort-direction="tableCallLogSettings.sortDirection"
                    :filter="tableCallLogSettings.filter"
                    :filter-included-fields="tableCallLogSettings.filterOn"
                    show-empty
                  >
                    <template #cell(index)="data">
                      {{ tableCallLogSettings.currentPage * tableCallLogSettings.perPage - tableCallLogSettings.perPage + (data.index + 1) }}
                    </template>

                    <template #cell()="data">
                      <div class="text-nowrap">
                        {{ data.value }}
                      </div>
                    </template>

                    <template #cell(actions)="row">
                      <div class="text-nowrap">
                        <b-button
                          size="sm"
                          variant="secondary"
                          class="mr-2"
                          @click="onViewRemarks(row.item)"
                        >
                          View
                        </b-button>
                      </div>
                    </template>

                  </b-table>

                  <b-row>
                    <b-col
                      cols="12"
                      sm="6"
                    >
                      <div class="w-100 w-sm-25 mb-2 sm-mb-2">
                        <b-select
                          v-model="tableCallLogSettings.perPage"
                          :options="tableCallLogSettings.pageOptions"
                          size="sm"
                        />
                      </div>
                    </b-col>
                    <b-col
                      cols="12"
                      sm="6"
                      class="d-flex justify-content-center justify-content-sm-end"
                    >
                      <b-pagination
                        v-model="tableCallLogSettings.currentPage"
                        :total-rows="tableCallLogSettings.totalRows"
                        :per-page="tableCallLogSettings.perPage"
                        first-number
                        last-number
                        pills
                        prev-text="Prev"
                        next-text="Next"
                        aria-controls="table"
                      />
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="12">
                  <b-form-group>
                    <label><strong>Previous Remarks</strong></label>
                    <b-textarea
                      :value="allComments"
                      rows="10"
                      max-rows="10"
                      :disabled="true"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="call status"
                    vid="call_status"
                    rules="required"
                  >
                    <b-form-group>
                      <label for="call_status"><strong>Call Status</strong></label>
                      <v-select
                        id="call_status"
                        v-model="selected2.call_status"
                        :options="options.call_statuses"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="text"
                        :disabled="state.busy"
                        placeholder="-- Please Select Call Status --"
                      >
                        <template #option="{ text }">
                          <span>{{ text }}</span>
                        </template>
                        <template #no-options="">
                          No Available Call Statuses
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="unsuccessful reason"
                    vid="unsuccessful_reason"
                    :rules="rulesUnsuccessfulReason"
                  >
                    <b-form-group>
                      <label for="unsuccessful_reason"><strong>Unsuccessful Reason</strong></label>
                      <v-select
                        id="unsuccessful_reason"
                        v-model="selected2.unsuccessful_reason"
                        :options="list.unsuccessful_reasons"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="reason_name"
                        :disabled="(state.busy || dealer.call_status !== 'Unsuccessful')"
                        placeholder="-- Please Select Unsuccessful Reason --"
                      >
                        <template #option="{ reason_name }">
                          <span>{{ reason_name }}</span>
                        </template>
                        <template #no-options="">
                          No Available Unsuccessful Reasons
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="disposition type"
                    vid="disposition_type"
                    :rules="rulesDispositionType"
                  >
                    <b-form-group>
                      <label for="disposition_type"><strong>Disposition Type</strong></label>
                      <v-select
                        id="disposition_type"
                        v-model="selected2.disposition_type"
                        :options="filteredDispositionTypes"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="type_name"
                        :disabled="(state.busy || dealer.call_status !== 'Connected')"
                        placeholder="-- Please Select Disposition Type --"
                      >
                        <template #option="{ type_name }">
                          <span>{{ type_name }}</span>
                        </template>
                        <template #no-options="">
                          No Available Disposition Types
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="disposition"
                    vid="disposition"
                    :rules="rulesDisposition"
                  >
                    <b-form-group>
                      <label for="sub_disposition"><strong>Disposition</strong></label>
                      <v-select
                        id="disposition"
                        v-model="selected2.disposition"
                        :options="list.dispositions"
                        :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                        label="disposition_name"
                        :disabled="(state.busy || dealer.call_status !== 'Connected')"
                        placeholder="-- Please Select Disposition --"
                      >
                        <template #option="{ disposition_name }">
                          <span>{{ disposition_name }}</span>
                        </template>
                        <template #no-options="">
                          No Available Disposition
                        </template>
                      </v-select>
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>

                <b-col cols="12">
                  <ValidationProvider
                    #default="{ errors }"
                    name="remarks"
                    vid="remarks"
                    rules="required|max:1000"
                  >
                    <b-form-group>
                      <label for="remarks"><strong>Remarks</strong></label>
                      <b-textarea
                        id="remarks"
                        v-model="dealer.remarks"
                        type="text"
                        :state="errors.length > 0 ? false : null"
                        placeholder="enter remarks"
                        autocomplete="off"
                        rows="6"
                        max-rows="6"
                        :disabled="state.busy"
                      />
                      <div
                        v-if="errors.length > 0"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
              </b-row>
            </b-tab>

          </b-tabs>
        </form>
      </ValidationObserver>

      <template #modal-footer="{ok, cancel}">
        <b-button
          variant="success"
          :disabled="(state.busy || state.representativeEditing || state.storeEditing)"
          @click="ok()"
        >
          {{ state.editing ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="danger"
          :disabled="state.busy"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-view-remarks"
      title="View Details"
      size="lg"
      scrollable
      no-close-on-backdrop
    >
      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Disposed At</label>
            <b-input
              :value="dateTimeFormatter(selected2.log?.created_at)"
              :disabled="true"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Agent</label>
            <b-input
              :value="selected2.log?.agent_name"
              :disabled="true"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Channel Name</label>
            <b-input
              :value="selected2.log?.channel_name"
              :disabled="true"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Call Status</label>
            <b-input
              :value="selected2.log?.call_status"
              :disabled="true"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
        >
          <b-form-group>
            <label>Unsuccessful Reason</label>
            <b-input
              :value="selected2.log?.unsuccessful_reason_name"
              :disabled="true"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Disposition Type</label>
            <b-input
              :value="selected2.log?.disposition_type_name"
              :disabled="true"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label>Disposition</label>
            <b-input
              :value="selected2.log?.disposition_name"
              :disabled="true"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
        >
          <b-form-group>
            <label>Promotion</label>
            <b-input
              :value="selected2.log?.promotion_name"
              :disabled="true"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group>
            <label>Remarks</label>
            <b-textarea
              :value="selected2.log?.remarks"
              rows="10"
              max-rows="10"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="danger"
          :disabled="state.busy"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
import _ from 'lodash'
import { core } from '@/config/pluginInit'
import { AxiosError, AgentDealerService, SharedListService, SharedLogService } from '@/services'
import formatter from '@/mixins/formatter'
import misc from '@/mixins/misc'

export default {
  name: 'AgentDealerMasterData',

  middleware: ['auth', 'agent'],

  metaInfo () {
    return {
      title: 'Master Data'
    }
  },

  mixins: [formatter, misc],

  data () {
    return {
      state: {
        busy: false,
        representativeEditing: false,
        storeEditing: false
      },
      list: {
        clusters: [],
        areas: [],
        filter_areas: [],
        distributions: [],
        provinces: [],
        municipalities_one: [],
        municipalities_two: [],
        municipalities_three: [],
        barangays_one: [],
        barangays_two: [],
        barangays_three: [],
        unsuccessful_reasons: [],
        disposition_types: [],
        dispositions: [],
        activities: []
      },
      filter: {
        cluster: 'All',
        area: 'All',
        status: 'All'
      },
      selected: {
        cluster: null,
        area: null
      },
      selected2: {
        current: null,
        log: null,
        cluster: null,
        area: null,
        distribution: null,
        province_one: null,
        municipality_one: null,
        barangay_one: null,
        province_two: null,
        municipality_two: null,
        barangay_two: null,
        call_status: null,
        unsuccessful_reason: null,
        disposition_type: null,
        disposition: null
      },
      selected3: {
        current: null,
        province: null,
        municipality: null,
        barangay: null
      },
      options: {
        statuses: [
          { text: 'Active', value: 'Active' },
          { text: 'Dormant', value: 'Dormant' },
          { text: 'Closed', value: 'Closed' },
          { text: 'Refused', value: 'Refused' },
          { text: 'Hold', value: 'Hold' }
        ],
        call_statuses: [
          { text: 'Connected', value: 'Connected' },
          { text: 'Unsuccessful', value: 'Unsuccessful' }
        ]
      },
      dealer: {
        id: 0,
        status: null,
        partner_code: '',
        partner_name: '',
        business_address: '',
        province_one: null,
        municipality_one: null,
        barangay_one: null,
        home_address: '',
        province_two: null,
        municipality_two: null,
        barangay_two: null,
        distribution: null,
        cluster: null,
        area: null,
        representatives: [],
        dirty_representatives: [],
        stores: [],
        dirty_stores: [],
        channel: 1,
        call_status: null,
        unsuccessful_reason: null,
        disposition_type: null,
        disposition: null,
        remarks: ''
      },
      representative: {
        id: 0,
        active: 0,
        name: '',
        birth_date: null,
        phone_one: '',
        phone_two: '',
        mobile_one: '',
        mobile_two: '',
        viber: '',
        email: '',
        created_at: null,
        updated_at: null
      },
      store: {
        id: 0,
        active: 0,
        store_name: '',
        store_address: '',
        province_id: 0,
        province: null,
        municipality_id: 0,
        municipality: null,
        barangay_id: 0,
        barangay: null,
        created_at: null,
        updated_at: null
      },
      tableSettings: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'status' },
          { key: 'partner_code' },
          { key: 'partner_name' },
          { key: 'cluster.cluster_name', label: 'cluster' },
          { key: 'area.area_name', label: 'area' },
          { key: 'last_call_status', label: 'last status' },
          { key: 'last_call', formatter: this.dateTimeFormatterLong, sortable: true },
          { key: 'last_agent_name', label: 'last agent' },
          { key: 'unsuccessful_reason_name', label: 'last unsuccessful reason' },
          { key: 'updated_at', formatter: this.dateTimeFormatter, sortable: true }
        ]
      },
      tableRepresetativeSettings: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: true,
        sortDirection: 'desc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'name' },
          { key: 'phone_one', label: 'phone 1' },
          { key: 'phone_two', label: 'phone 2' },
          { key: 'mobile_one', label: 'mobile 1' },
          { key: 'mobile_two', label: 'mobile 2' },
          { key: 'email' },
          { key: 'viber' },
          { key: 'updated_at', formatter: this.dateTimeFormatter }
        ]
      },
      tableStoreSettings: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: true,
        sortDirection: 'desc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'store_name' },
          { key: 'province.province_name', label: 'province' },
          { key: 'municipality.municipality_name', label: 'municipality' },
          { key: 'barangay.barangay_name', label: 'barangay' },
          { key: 'updated_at', formatter: this.dateTimeFormatter }
        ]
      },
      tableCallLogSettings: {
        perPage: 5,
        pageOptions: [5, 10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'agent_name', label: 'agent' },
          { key: 'channel_name' },
          { key: 'call_status' },
          { key: 'unsuccessful_reason_name', label: 'unsuccessful reason' },
          { key: 'disposition_type_name', label: 'disposition type' },
          { key: 'disposition_name', label: 'disposition' }
        ]
      },
      allComments: ''
      // tableActivityLogSettings: {
      //   perPage: 10,
      //   pageOptions: [10, 25, 50, 100],
      //   totalRows: 0,
      //   currentPage: 1,
      //   sortBy: '',
      //   sortDesc: false,
      //   sortDirection: 'asc',
      //   filter: '',
      //   filterOn: [],
      //   fields: [
      //     'index',
      //     { key: 'activity_date', label: 'date', formatter: this.dateFormatter, sortable: true },
      //     { key: 'user_name', label: 'user' },
      //     { key: 'activity_name', label: 'activity' }
      //   ]
      // }
    }
  },

  computed: {
    rulesUnsuccessfulReason () {
      if (this.dealer.call_status === 'Unsuccessful') {
        return 'required'
      }

      return ''
    },

    rulesDispositionType () {
      if (this.dealer.call_status === 'Connected') {
        return 'required'
      }

      return ''
    },

    rulesDisposition () {
      if (this.dealer.call_status === 'Connected') {
        return 'required'
      }

      return ''
    },

    rulesPromotion () {
      if (this.dealer.call_status === 'Successful') {
        return 'required'
      }

      return ''
    },

    filterStatuses () {
      return [{ text: 'All', value: 'All' }].concat(this.options.statuses)
    },

    filteredDispositionTypes () {
      const dispositionTypes = [3, 6, 18]
      return this.list.disposition_types.filter(item => dispositionTypes.includes(item.id))
    },

    filteredRepresentatives () {
      return this.dealer.representatives.filter(item => item.active === 1)
    },

    representativeButtonLabel () {
      if (this.state.representativeEditing) {
        return 'Update'
      }

      return 'Insert'
    },

    representativeButtonVariant () {
      if (this.state.representativeEditing) {
        return 'secondary'
      }

      return 'success'
    },

    representativeButtonDisabledState () {
      return !(this.representative.name.length > 0)
    },

    filteredStores () {
      return this.dealer.stores.filter(item => item.active === 1)
    },

    storeButtonLabel () {
      if (this.state.storeEditing) {
        return 'Update'
      }

      return 'Insert'
    },

    storeButtonVariant () {
      if (this.state.storeEditing) {
        return 'secondary'
      }

      return 'success'
    },

    storeButtonDisabledState () {
      return !(this.store.store_name.length > 0 && this.store.store_address.length > 0)
    }
  },

  watch: {
    'selected.cluster' (value) {
      this.filter.cluster = value?.id || 'all'
      this.getFilterAreas(value?.id || null)
      this.onFilterChanged()
    },

    'selected.area' (value) {
      this.filter.area = value?.id || 'all'
      this.onFilterChanged()
    },

    'selected2.cluster' (value) {
      this.dealer.cluster = value?.id || null
      this.getAreas(this.dealer.cluster)
    },

    'selected2.area' (value) {
      this.dealer.area = value?.id || null
    },

    'selected2.distribution' (value) {
      this.dealer.distribution = value?.id || null
    },

    'selected2.province_one' (value) {
      this.dealer.province_one = value?.id || null
      this.getMunicipalities(this.dealer.province_one)
    },

    'selected2.municipality_one' (value) {
      this.dealer.municipality_one = value?.id || null
      this.getBarangays(this.dealer.municipality_one)
    },

    'selected2.barangay_one' (value) {
      this.dealer.barangay_one = value?.id || null
    },

    'selected2.province_two' (value) {
      this.dealer.province_two = value?.id || null
      this.getMunicipalitiesTwo(this.dealer.province_two)
    },

    'selected2.municipality_two' (value) {
      this.dealer.municipality_two = value?.id || null
      this.getBarangaysTwo(this.dealer.municipality_two)
    },

    'selected2.barangay_two' (value) {
      this.dealer.barangay_two = value?.id || null
    },

    'selected2.call_status' (value) {
      this.dealer.call_status = value?.value || null
      if (!this.dealer.call_status) {
        this.selected2.unsuccessful_reason = null
        this.selected2.disposition_type = null
        this.selected2.disposition = null
        this.selected2.promotion = null
      }

      if (this.dealer.call_status === 'Connected') {
        this.selected2.unsuccessful_reason = null
      }

      if (this.dealer.call_status === 'Unsuccessful') {
        this.selected2.disposition_type = null
        this.selected2.disposition = null
        this.selected2.promotion = null
      }
    },

    'selected2.unsuccessful_reason' (value) {
      this.dealer.unsuccessful_reason = value?.id || null
    },

    'selected2.disposition_type' (value) {
      this.dealer.disposition_type = value?.id || null
      this.getDispositions(this.dealer.disposition_type)
    },

    'selected2.disposition' (value) {
      this.dealer.disposition = value?.id || null
    },

    'selected3.province' (value) {
      this.store.province_id = value?.id || null
      this.getMunicipalitiesThree(this.store.province_id)
    },

    'selected3.municipality' (value) {
      this.store.municipality_id = value?.id || null
      this.getBarangaysThree(this.store.municipality_id)
    },

    'selected3.barangay' (value) {
      this.store.barangay_id = value?.id || null
    },

    'dealer.representatives' (value) {
      this.tableRepresetativeSettings.totalRows = value?.length || 0
    },

    'dealer.stores' (value) {
      this.tableStoreSettings.totalRows = value?.length || 0
    }
  },

  mounted () {
    core.index()
    this.getClusters()
    this.getDistributions()
    this.getProvinces()
    this.getActivities()
    this.getUnsuccessfulReasons()
    this.getDispositionTypes()
  },

  methods: {
    async myProvider (ctx) {
      try {
        const { data } = await AgentDealerService.get(
          this.objectToUrl({
            page: ctx.currentPage,
            per_page: ctx.perPage,
            sort: ctx.sortBy,
            sort_desc: ctx.sortDesc,
            filter_text: ctx.filter,
            filter_cluster: this.filter.cluster,
            filter_area: this.filter.area,
            filter_status: this.filter.status
          })
        )
        this.tableSettings.totalRows = data.total_rows
        return data.items
      } catch {
        return []
      }
    },

    async myLogProvider (ctx) {
      try {
        const { data } = await SharedLogService.getDealerLogs(
          this.objectToUrl({
            page: ctx.currentPage,
            per_page: ctx.perPage,
            sort: ctx.sortBy,
            sort_desc: ctx.sortDesc,
            filter_text: ctx.filter,
            dealer_id: this.dealer.id
          })
        )
        this.tableCallLogSettings.totalRows = data.total_rows
        this.allComments = ''
        data.items.forEach(log => {
          const remarks = `${this.dateTimeFormatterLong(log.created_at)} [${log.agent_name} thru ${log.channel_name}]: ${log.remarks}\r\n\r\n`
          this.allComments += remarks
        })
        return data.items
      } catch (e) {
        return []
      }
    },

    async myActivityLogProvider (ctx) {
      try {
        const { data } = await SharedLogService.getDealerLogs(
          this.objectToUrl({
            page: ctx.currentPage,
            per_page: ctx.perPage,
            sort: ctx.sortBy,
            sort_desc: ctx.sortDesc,
            filter_text: ctx.filter,
            dealer_id: this.account.id
          })
        )
        this.tableActivityLogSettings.totalRows = data.total_rows
        return data.items
      } catch {
        return []
      }
    },

    async getClusters () {
      await SharedListService.getClusters().then(({ data }) => {
        this.list.clusters = data
      })
    },

    async getAreas (cluster) {
      this.selected2.area = null
      if (cluster) {
        this.list.areas = []
        await SharedListService.getAreas(`cluster_id=${cluster}`).then(({ data }) => {
          if (this.state.editing) {
            if (this.selected2.current.area) {
              this.selected2.area = {
                id: this.selected2.current.area.id,
                area_name: this.selected2.current.area.area_name
              }
              this.selected2.current.area = null
            }
          }
        })
      } else {
        this.list.areas = []
      }
    },

    async getFilterAreas (cluster) {
      this.selected.area = null
      if (cluster) {
        this.list.filter_areas = []
        await SharedListService.getAreas(`cluster_id=${cluster}`).then(({ data }) => {
          this.list.filter_areas = data
        })
      } else {
        this.list.filter_areas = []
      }
    },

    async getDistributions () {
      await SharedListService.getDistributions().then(({ data }) => {
        this.list.distributions = data
      })
    },

    async getProvinces () {
      await SharedListService.getProvinces().then(({ data }) => {
        this.list.provinces = data
      })
    },

    async getMunicipalities (province) {
      this.selected2.municipality_one = null
      if (province) {
        await SharedListService.getMunicipalities(`province_id=${province}`).then(({ data }) => {
          this.list.municipalities_one = data
          if (this.state.editing) {
            if (this.selected2.current.municipality_one) {
              this.selected2.municipality_one = {
                id: this.selected2.current.municipality_one.id,
                municipality_name: this.selected2.current.municipality_one.municipality_name
              }
              this.selected2.current.municipality_one = null
            }
          }
        })
      } else {
        this.list.municipalities_one = []
      }
    },

    async getBarangays (municipality) {
      this.selected2.barangay_one = null
      if (municipality) {
        await SharedListService.getBarangays(`municipality_id=${municipality}`).then(({ data }) => {
          this.list.barangays_one = data
          if (this.state.editing) {
            if (this.selected2.current.barangay_one) {
              this.selected2.barangay_one = {
                id: this.selected2.current.barangay_one.id,
                barangay_name: this.selected2.current.barangay_one.barangay_name
              }
              this.selected2.current.barangay_one = null
            }
          }
        })
      } else {
        this.list.barangays_one = []
      }
    },

    async getMunicipalitiesTwo (province) {
      this.selected2.municipality_two = null
      if (province) {
        await SharedListService.getMunicipalities(`province_id=${province}`).then(({ data }) => {
          this.list.municipalities_two = data
          if (this.state.editing) {
            if (this.selected2.current.municipality_two) {
              this.selected2.municipality_two = {
                id: this.selected2.current.municipality_two.id,
                municipality_name: this.selected2.current.municipality_two.municipality_name
              }
              this.selected2.current.municipality_two = null
            }
          }
        })
      } else {
        this.list.municipalities_two = []
      }
    },

    async getBarangaysTwo (municipality) {
      this.selected2.barangay_two = null
      if (municipality) {
        await SharedListService.getBarangays(`municipality_id=${municipality}`).then(({ data }) => {
          this.list.barangays_two = data
          if (this.state.editing) {
            if (this.selected2.current.barangay_two) {
              this.selected2.barangay_two = {
                id: this.selected2.current.barangay_two.id,
                barangay_name: this.selected2.current.barangay_two.barangay_name
              }
              this.selected2.current.barangay_two = null
            }
          }
        })
      } else {
        this.list.barangays_two = []
      }
    },

    async getMunicipalitiesThree (province) {
      this.selected3.municipality = null
      if (province) {
        await SharedListService.getMunicipalities(`province_id=${province}`).then(({ data }) => {
          this.list.municipalities_three = data
          if (this.state.storeEditing) {
            if (this.selected3.current.municipality) {
              this.selected3.municipality = {
                id: this.selected3.current.municipality.id,
                municipality_name: this.selected3.current.municipality.municipality_name
              }
              this.selected3.current.municipality = null
            }
          }
        })
      } else {
        this.list.municipalities_three = []
      }
    },

    async getBarangaysThree (municipality) {
      this.selected3.barangay = null
      if (municipality) {
        await SharedListService.getBarangays(`municipality_id=${municipality}`).then(({ data }) => {
          this.list.barangays_three = data
          if (this.state.storeEditing) {
            if (this.selected3.current.barangay) {
              this.selected3.barangay = {
                id: this.selected3.current.barangay.id,
                barangay_name: this.selected3.current.barangay.barangay_name
              }
            }
            this.selected3.current.barangay = null
          }
        })
      } else {
        this.list.barangays_three = []
      }
    },

    async getUnsuccessfulReasons () {
      await SharedListService.getUnsuccessfulReasons().then(({ data }) => {
        this.list.unsuccessful_reasons = data
      })
    },

    async getDispositionTypes () {
      await SharedListService.getDispositionTypes(`channel_id=${this.dealer.channel}`).then(({ data }) => {
        this.list.disposition_types = data
      })
    },

    async getDispositions (dispositionType) {
      this.selected2.disposition = null
      if (dispositionType) {
        await SharedListService.getDispositions(`disposition_type_id=${dispositionType}`).then(({ data }) => {
          this.list.dispositions = data
        })
      } else {
        this.list.dispositions = []
      }
    },

    async getActivities () {
      await SharedListService.getActivities().then(({ data }) => {
        this.list.activities = data.map(item => {
          return {
            value: item.id,
            text: item.activity_name
          }
        })
      })
    },

    onShowEditForm (current) {
      this.state.editing = true
      this.selected2.current = { ...current }
      this.selected2.cluster = null
      this.selected2.area = null
      this.selected2.distribution = null
      this.selected2.province_one = null
      this.selected2.municipality_one = null
      this.selected2.barangay_one = null
      this.selected2.province_two = null
      this.selected2.municipality_two = null
      this.selected2.barangay_two = null
      this.selected2.call_status = null
      this.selected2.unsuccessful_reason = null
      this.selected2.disposition_type = null
      this.selected2.disposition = null
      this.dealer.id = current.id
      this.dealer.status = current.status
      this.dealer.partner_code = current.partner_code
      this.dealer.partner_name = current.partner_name
      this.dealer.business_address = current.business_address
      this.dealer.home_address = current.home_address
      this.dealer.representatives = current.representatives
      this.dealer.stores = current.stores
      this.dealer.remarks = ''

      if (current.cluster) {
        this.selected2.cluster = {
          id: current.cluster.id,
          cluster_name: current.cluster.cluster_name
        }
      }

      if (current.distribution) {
        this.selected2.distribution = {
          id: current.distribution.id,
          distribution_name: current.distribution.distribution_name
        }
      }

      if (current.province_one) {
        this.selected2.province_one = {
          id: current.province_one.id,
          province_name: current.province_one.province_name
        }
      }

      if (current.province_two) {
        this.selected2.province_two = {
          id: current.province_two.id,
          province_name: current.province_two.province_name
        }
      }

      // reset form
      this.onRepresentativeReset()
      this.onStoreReset()

      this.$bvModal.show('modal-dealer-form')
    },

    onViewRemarks (current) {
      this.selected2.log = { ...current }
      this.$bvModal.show('modal-view-remarks')
    },

    onRepresentativeReset () {
      this.representative.id = 0
      this.representative.active = 0
      this.representative.name = ''
      this.representative.birth_date = null
      this.representative.phone_one = ''
      this.representative.phone_two = ''
      this.representative.mobile_one = ''
      this.representative.mobile_two = ''
      this.representative.viber = ''
      this.representative.email = ''
      this.representative.created_at = null
      this.representative.updated_at = null
    },

    onRepresentativeButtonClick () {
      if (this.state.representativeEditing) {
        this.onRepresentativeUpdate()
        return
      }

      this.onRepresentativeInsert()
    },

    onRepresentativeInsert () {
      // && this.representative.mobile_one.length > 0
      if (!(this.representative.name.length > 0)) {
        return
      }

      const newId = this.generateId(10)

      this.representative.id = newId
      this.representative.active = 1

      this.dealer.representatives.push({
        ...this.representative
      })

      this.onRepresentativeReset()
    },

    onRepresentativeEdit (current) {
      this.state.representativeEditing = true
      this.representative.id = current.id
      this.representative.active = current.active
      this.representative.name = current.name
      this.representative.birth_date = current.birth_date
      this.representative.phone_one = current.phone_one
      this.representative.phone_two = current.phone_two
      this.representative.mobile_one = current.mobile_one
      this.representative.mobile_two = current.mobile_two
      this.representative.email = current.email
      this.representative.viber = current.viber
    },

    onRepresentativeUpdate () {
      const representative = _.find(this.dealer.representatives, { id: this.representative.id })

      if (representative) {
        representative.name = this.representative.name
        representative.birth_date = this.representative.birth_date
        representative.phone_one = this.representative.phone_one
        representative.phone_two = this.representative.phone_two
        representative.mobile_one = this.representative.mobile_one
        representative.mobile_two = this.representative.mobile_two
        representative.email = this.representative.email
        representative.viber = this.representative.viber
      }

      // add to dirty list
      if (_.indexOf(this.dealer.dirty_representatives, this.representative.id) < 0) {
        this.dealer.dirty_representatives.push(this.representative.id)
      }

      this.state.representativeEditing = false
      this.onRepresentativeReset()
    },

    onRepresentativeCancelUpdate () {
      this.state.representativeEditing = false
      this.onRepresentativeReset()
    },

    onRepresentativeRemove (current) {
      if (!isNaN(parseInt(current.id))) {
        return
      }

      this.dealer.representatives = _.remove(this.dealer.representatives, function (o) {
        return o.id.toString() !== current.id.toString()
      })
    },

    onStoreReset () {
      this.state.storeEditing = false
      this.store.id = 0
      this.store.active = 0
      this.store.store_name = ''
      this.store.store_address = ''
      this.store.created_at = null
      this.store.updated_at = null
      this.selected3.province = null
      this.selected3.municipality = null
      this.selected3.barangay = null
    },

    onStoreButtonClick () {
      if (this.state.storeEditing) {
        this.onStoreUpdate()
        return
      }

      this.onStoreInsert()
    },

    onStoreInsert () {
      if (!(this.store.store_name.length > 0 && this.store.store_address.length > 0)) {
        return
      }

      const newId = this.generateId(10)

      this.store.id = newId
      this.store.active = 1
      this.store.province = _.find(this.list.provinces, { id: this.store.province_id })
      this.store.municipality = _.find(this.list.municipalities_three, { id: this.store.municipality_id })
      this.store.barangay = _.find(this.list.barangays_three, { id: this.store.barangay_id })

      this.dealer.stores.push({
        ...this.store
      })

      this.onStoreReset()
    },

    onStoreEdit (current) {
      this.state.storeEditing = true
      this.selected3.current = { ...current }
      this.store.id = current.id
      this.store.store_name = current.store_name
      this.store.store_address = current.store_address
      this.store.active = current.active
      this.store.created_at = current.created_at
      this.store.updated_at = current.updated_at

      if (current.province_one) {
        this.selected3.province = {
          id: current.province_one.id,
          province_name: current.province_one.province_name
        }
      }
    },

    onStoreUpdate () {
      const store = _.find(this.dealer.stores, { id: this.store.id })

      if (store) {
        store.store_name = this.store.store_name
        store.store_address = this.store.store_address
        store.province = _.find(this.list.provinces, { id: this.store.province_id })
        store.municipality = _.find(this.list.municipalities_three, { id: this.store.municipality_id })
        store.barangay = _.find(this.list.barangays_three, { id: this.store.barangay_id })
      }

      // add to dirty list
      if (_.indexOf(this.dealer.dirty_stores, this.store.id) < 0 && !isNaN(this.store.id)) {
        this.dealer.dirty_stores.push(this.store.id)
      }

      this.state.storeEditing = false
      this.onStoreReset()
    },

    onStoreCancelUpdate () {
      this.state.storeEditing = false
      this.onStoreReset()
    },

    onStoreRemove (current) {
      if (!isNaN(parseInt(current.id))) {
        return
      }

      this.dealer.stores = _.remove(this.dealer.stores, function (o) {
        return o.id.toString() !== current.id.toString()
      })
    },

    async onConfirmAction (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.form.validate().then(async success => {
        if (success) {
          this.$swal.fire({
            icon: 'question',
            title: 'Question',
            text: 'Do you really want to save changes?',
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#FF2929',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: () => {
              return this.onFormPutSubmit()
            },
            allowOutsideClick: () => !this.$swal.isLoading()
          })
        } else {
          this.$bvModal.msgBoxOk('Oops! There were problem with your inputs.', {
            title: 'Validation Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            centered: true
          })
        }
      })
    },

    async onFormPutSubmit () {
      return new Promise(resolve => {
        this.state.busy = true
        AgentDealerService.put(this.dealer).then(({ data }) => {
          this.$bvModal.hide('modal-dealer-form')
          this.state.busy = false
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            const row = _.find(this.$refs.table.localItems, { id: data.dealer.id })
            row.status = data.dealer.status
            row.partner_code = data.dealer.partner_code
            row.partner_name = data.dealer.partner_name
            row.cluster = data.dealer.cluster
            row.area = data.dealer.area
            row.business_address = data.dealer.business_address
            row.province_one = data.dealer.province_one
            row.municipality_one = data.dealer.municipality_one
            row.barangay_one = data.dealer.barangay_one
            row.home_address = data.dealer.home_address
            row.province_two = data.dealer.province_two
            row.municipality_two = data.dealer.municipality_two
            row.barangay_two = data.dealer.barangay_two
            row.representatives = data.representatives
            row.stores = data.stores
            row.last_call = data.dealer.last_call
            row.last_call_status = data.dealer.last_call_status
            row.last_agent_name = data.dealer.last_agent_name
            row.unsuccessful_reason_name = data.dealer.unsuccessful_reason_name
            row.updated_at = data.dealer.updated_at
          })
        }).catch(error => {
          this.state.busy = false
          if (error instanceof AxiosError) {
            if (error.code === 422) {
              this.$refs.form.setErrors(error.message)
              this.$bvModal.msgBoxOk('Oops! There were problem with your inputs.', {
                title: 'Validation Error',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                centered: true
              })
              resolve(error)
            }
          }
        })
      })
    },

    onFilterChanged () {
      this.$refs.table.refresh()
    }
  }
}
</script>
